var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 620 562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d26053",
    d: "M291.5 21.5c104.733-2.067 184.566 40.933 239.5 129 40.535 75.567 44.201 152.9 11 232-44.695 91.139-117.862 141.306-219.5 150.5-90.53 2.31-163.697-31.856-219.5-102.5C53.594 360.165 40.594 283.498 64 200.5 92.5 117.333 148.333 61.5 231.5 33c19.787-5.683 39.787-9.517 60-11.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6f6",
    d: "M289.5 69.5c87.821-3.35 154.654 31.983 200.5 106 31.277 58.611 34.944 118.944 11 181-32.55 72.189-88.05 114.689-166.5 127.5-82.629 7.257-148.463-22.243-197.5-88.5-40.483-63.224-47.15-129.891-20-200C151.805 122.54 209.305 80.54 289.5 69.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d26053",
    d: "M298.5 134.5c11.272-1.352 21.938.482 32 5.5 4.318 3.315 7.485 7.481 9.5 12.5.667 51.333.667 102.667 0 154-4.65 10.631-12.817 16.798-24.5 18.5-8.638 1.274-16.972.274-25-3-6.649-3.314-11.149-8.481-13.5-15.5-.667-51.333-.667-102.667 0-154 4.31-9.482 11.477-15.482 21.5-18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d26154",
    d: "M301.5 357.5c19.329-1.59 32.162 6.744 38.5 25 .92 26.413-11.913 39.247-38.5 38.5-18.399-6.293-26.565-19.127-24.5-38.5 4.044-12.542 12.21-20.876 24.5-25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamationIcon.8814d1d959527feb80ab4bf9669c6275.svg";
export { ForwardRef as ReactComponent };